import { useEffect } from 'react';
import Lenis from 'lenis';

export const useSmoothScroll = (enabled, lerp = 0.1) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const lenis = new Lenis({ lerp, smoothWheel: true });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, [enabled, lerp]);
};
